<template>
  <div>
    <div class="content">
      <div class="header-table">
        <table>
          <tbody>
            <tr>
              <td class="header-in-table">작업장 일반 자율점검표</td>
              <td rowspan="2" class="th-background" style="width: 40px">결<br /><br />재</td>
              <td class="th-background" style="width: 230px">확인자</td>
            </tr>
            <tr>
              <td class="content-title" valign="bottom"><i class="dot"></i> 기본정보</td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign1 !== 'undefined' ? `url(${form.sign1.sign})` : '' }"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <table>
          <tbody>
            <tr>
              <th>회사명</th>
              <td>{{ form.stdInfo.field_name }}</td>
              <th>소속명</th>
              <td>{{ form.stdInfo.department }}</td>
              <th>부서명</th>
              <td>{{ form.stdInfo.com_name }}</td>
            </tr>
            <tr>
              <th>직책</th>
              <td>{{ form.stdInfo.rank }}</td>
              <th>작성자</th>
              <td>{{ form.stdInfo.writer_name }}</td>
              <th>작성일</th>
              <td>{{ form.stdInfo.date }}</td>
            </tr>
            <tr>
              <th>점검자</th>
              <td>{{ form.점검자 }}</td>
              <th>점검일</th>
              <td colspan="3">{{ form.점검일 }}</td>
            </tr>
            <tr>
              <th>점검구분</th>
              <td colspan="5">
                <div class="grid grid-cols-4 gap-x-6 gap-y-4 p-4">
                  <div v-for="(_title, _title_i) in getTitles" :key="`checkbox_${_title}`" class="col-span-1 flex items-center">
                    <div class="flex items-center">
                      <div v-if="form.inspectChecked.includes(_title)" style="background: #696D71;" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
                        <vs-icon icon="check" size="x-small"></vs-icon>
                      </div>
                      <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
                      <span class="flex-1">{{ _title }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <TableInspectMerge
      v-for="item in form.inspectList"
      :key="`inspect_${item.title}`"
      v-show="form.inspectChecked.includes(item.title)"
      :is-print="true"
      :is-readonly="board.readonly"
      :only-pc="true"
      :title="item.title"
      :tableHeaderTitle="item.tableHeaderTitle || '자가진단 항목'"
      :table-header-note="[{ text: '비고(보완계획)', width: '240' }]"
      v-model="item.list"
      class="mt-5 table-inspect-merge-print"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      class="mt-3"
      v-model="form.photoList"
      :is-print="true"
      :customTitle="true"
      :printRowCount="1"
      section-title="사진대지"
      placeholder="점검 현장 사진">
      <template #customTitle>
        <div style="font-size: 24px; font-weight: 700; line-height: 35px; padding-bottom: 16px">□ 사진대지</div>
      </template>
    </photo-upload-grid-module>
  </div>
</template>

<script>
import inspectData from "./inspectData";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
export default {
  name: "Print163",
  components: {PhotoUploadGridModule, TableInspectMerge},
  props: {
    form: Object,
    board: Object,
  },
  computed: {
    getTitles() {
      if (!this.form.inspectList) {
        return [];
      }
      return this.form.inspectList.map((item) => item.title);
    },
  },
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content {
  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 14px;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 10px;
    }
  }
  .header-table {
    table {
      width: 100%;
      border-collapse: collapse;
      tr:nth-child(1) {
        text-align: center;
        td {
          padding: 10px;
        }
        td:nth-child(n + 2) {
          font-size: 18px;
          font-weight: 500;
          border-left: 1px solid #757575;
          border-top: 1px solid #757575;
          border-right: 1px solid #757575;
        }
      }
      tr:nth-child(2) {
        height: 100px;
        td:nth-child(1) {
          padding-bottom: 15px;
        }
        td:nth-child(n + 2) {
          border-left: 1px solid #757575;
          border-top: 1px solid #757575;
          border-right: 1px solid #757575;
        }
      }
    }
    .header-in-table {
      font-size: 32px;
      font-weight: 700;
      line-height: 24px;
    }
    .signCell {
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .content-table {
    .sub-header,
    .item-label {
      padding: 14px;
      text-align: left;
      font-size: 18px;
    }
    .sub-header {
      font-weight: 700;
    }
    .row-title {
      font-weight: 500;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 40px;

      th,
      td {
        border: 1px solid #757575;
        text-align: center;
        min-height: 55px;
        height: 55px;
        font-size: 18px;
      }
      th {
        background-color: #ececec;
        font-weight: 500;
        padding: 0;
      }
      td {
        min-width: 50px;
        word-break: keep-all;
        img {
          display: inline-block;
        }
      }
      .check-container {
        padding: 10px 14px 0 14px;
        text-align: left;

        div {
          margin-bottom: 8px;
        }
        img {
          display: inline-block;
          margin-right: 8px;
        }
      }
      .text-left {
        text-align: left;
        padding: 10px 14px;
      }
    }

    /*서명 테이블*/
    .sign-table {
      th,
      td {
        font-size: 14px;
      }

      tr th:nth-child(1),
      tr td:nth-child(1),
      tr th:nth-child(8),
      tr td:nth-child(8) {
        width: 64px;
      }

      .signCell {
        white-space: nowrap;
        min-width: 90px;
        padding: 2px;
        height: 50px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .signSpace {
        width: 10px;
        border-top: none;
        border-bottom: none;
      }
    }
  }

  .th-background {
    background-color: #ececec;
    white-space: nowrap;
  }
}

.photoWrap {
  .photoContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: dashed 1px $border-color;
    break-inside: avoid;
  }
}
.photoWrap:nth-child(2n) {
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.table-inspect-merge-print {
  h5 {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    color: #3c3c3c;

    display: flex;
    align-items: center;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 14px;
    }
  }

  .print-textarea,
  .print-input {
    border: none;
    border-radius: 0;
  }

  table {
    th,
    td {
      border: 1px solid #757575 !important;
      min-height: 55px !important;
      height: 55px !important;
      font-size: 18px !important;
      text-align: center !important;
    }
    th {
      background-color: #ececec !important;
      font-weight: 500 !important;
      padding: 0 !important;
    }

    .title-tr > td {
      background-color: #ececec !important;
      text-align: left !important;
    }

    .content[colspan='4'],
    .content[colspan='7']{
      padding: 0 !important;

      & > div {
        display: grid !important;
        grid-template-columns: auto 1fr;
        gap: 0 !important;
      }
      p {
        flex: none ;
        padding: 0.7rem !important;
        width: 140px !important;
        height: 100% !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        margin: 0 !important;
        border-left: 1px solid #757575 !important;
        white-space: pre-wrap;

        display: grid;
        align-items: center;
      }
    }
  }
}
</style>
